<template>
    <div class="PjanNavigationbar">
        <div class="tab_content" v-show="highcourt">
            <div class="tab_sent sent"  @click="substance('/newlpr')">
                <p>最新LPR，民间借贷利率法定上限为13.8%</p>
                <span>点击查看 >></span>
            </div>
            <div class="tab_sent" @click="substance('/resolution')">
                <p>多元纠纷化解</p>
                <span>点击查看 >></span>
            </div>
            <!-- <div class="tab_sent">
                <p>调解为债务人节省了约600多万元诉讼费</p>
                <span>点击查看 >></span>
            </div> -->
        </div>
        <router-view v-show="!highcourt"/>
    </div>
</template>
<script>
export default {
    data() {
        return {
            highcourt:true
        }
    },
    methods:{
        substance(data){
            // this.highcourt = false
            if(data == this.$route.path) return
            this.$router.push(data)
        }
    },
    watch:{
        $route(to,from){
            if(to.path == '/TjznNavigationbar'){
                this.highcourt = true
            }else{
                this.highcourt = false
            }
        }
    }
}
</script>
<style lang="less" scoped>
.PjanNavigationbar{
    width: 100%;
    .tab_content{
        p{
            width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .tab_sent:hover p,.tab_sent:hover span{
            color:#BE1A0F;
        }
    }
}
</style>
